export enum SecurityEntityType {
  User,
  Role
}
